export default __webpack_public_path__ + "static/assets/ed0ee289a23ad1c0cad58e1a2f7975c8.png";